import { render, staticRenderFns } from "./confirmRegion.vue?vue&type=template&id=450caf7a&scoped=true"
import script from "./confirmRegion.vue?vue&type=script&lang=js"
export * from "./confirmRegion.vue?vue&type=script&lang=js"
import style0 from "./confirmRegion.vue?vue&type=style&index=0&id=450caf7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450caf7a",
  null
  
)

export default component.exports